







import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 * 编辑 / 保存 按钮
 *
 * @author liyuyao
 * @date 12/23/2019
 */
@Component
export default class EditSave extends Vue {
    @Prop({ default: false })
    editable: Boolean;

    edit() {
        this.$emit('update:editable', true);
    }

    save() {
        this.$emit('save');
        // this.$emit('update:editable', false);
    }

    cancel() {
        this.$emit('cancel');
        this.$emit('update:editable', false);
    }
}
